import React from "react";
import { formatCurrency } from "../../../../helpers/estimateTotals";

function Line({ label, value, emphasis, testId }) {
  return (
    <div className={`sp-line${emphasis ? " is-emph" : ""}`}>
      <span>{label}</span>
      <span data-testid={testId}>{value}</span>
    </div>
  );
}

/** Right panel: live totals + surface area. All numbers arrive pre-computed from existing helpers. */
export function SummaryPanel({ featureName, featureTotal, locationName, locationTotal, estimateTotal, surfaceTotals, netSqft }) {
  return (
    <aside className="sp" aria-label="Live summary">
      <h3 className="sp__title">Live summary</h3>
      <Line label={featureName ? `Feature · ${featureName}` : "Feature"} value={formatCurrency(featureTotal)} testId="summary-feature" />
      <Line label={locationName ? `Location · ${locationName}` : "Location"} value={formatCurrency(locationTotal)} testId="summary-location" />
      <Line label="Estimate total" value={formatCurrency(estimateTotal)} emphasis testId="summary-estimate" />
      <hr className="sp__hr" />
      <h4 className="sp__sub">Surface area</h4>
      {surfaceTotals.length === 0 ? (
        <p className="sp__muted">No measurements yet.</p>
      ) : (
        <>
          {surfaceTotals.map((row) => (
            <div key={row.surfaceType} className="sp-line">
              <span>{row.label}</span>
              <span>{row.sqft.toFixed(1)} ft²</span>
            </div>
          ))}
          <div className="sp-line is-emph">
            <span>Net area</span>
            <span>{netSqft.toFixed(1)} ft²</span>
          </div>
        </>
      )}
      <p className="sp__note">Area includes each surface’s deductions and updates as you edit.</p>
    </aside>
  );
}
